<template>
  <div class>
    <el-tabs v-model="tabName">
      <el-tab-pane label="充电订单" name="first" >
        <STable
        v-if="tabName==='first'"
          ref="tableref"
          :url="url"
          :columns="columns"
          :handles="handles"
          :query="query"
          :selection="false"
          label-width="90px"
        />
      </el-tab-pane>
      <!-- <el-tab-pane label="实时占用记录" name="second" >
        <STable
        v-if="tabName==='second'"
          ref="tableref1"
          :url="url1"
          :columns="columns1"
          :handles="handles1"
          :query="query1"
          :selection="false"
          label-width="90px"
        />
      </el-tab-pane> -->
    </el-tabs>
  </div>
</template>

<script>
import fieldFilter from "@/utils/fieldFilter.js";
export default {
  name: "Shishidingdan",
  components: {},
  data() {
    return {
      tabName: "first",
      url: "/finance/order/currentOrderPage?view=STATION",
      url1: "/admin/occupyorder/listTmpOrder",
      columns: [
        {
          label: "充电单号",
          prop: "startChargeSeq",
        },
        {
          label: "用户账号",
          prop: "loginName",
        },
        {
          label: "归属企业",
          prop: "orgName",
        },
        {
          label: "充电车辆",
          prop: "plateNumber",
        },
        {
          label: "充电时长",
          prop: "hasChargingTime",
        },
        {
          label: "已充电量（度）",
          prop: "totalPower",
          template: (index, reocrd) => {
            return this.getFloat(reocrd.totalPower);
          },
        },
        {
          label: "当前SOC",
          prop: "SOC",
          template: (index, reocrd) => {
            return reocrd.SOC ? parseFloat(reocrd.SOC) + "%" : "--";
          },
        },
        {
          label: "电站名称",
          prop: "stationName",
        },
        {
          label: "终端编号",
          prop: "connectorCode",
          width: "150px",
        },
        {
          label: "终端名称",
          prop: "connectorName",
        },
        {
          label: "运营商",
          prop: "operatorName",
        },
        {
          label: "订单类型",
          prop: "orderType",
        },
        {
          label: "充电方式",
          prop: "chargeType",
        },
        // {
        //   label: "充电模式",
        //   prop: "chargingType",
        //   template: function (index, reocrd) {
        //     return reocrd.chargingType === 0 ? "单充" : (reocrd.chargingType === 1 ? "双枪并充" : "");
        //   },
        // },
        {
          label: "开始充电时间",
          prop: "startTime",
          width: "150px",
        },
      ],
      columns1: [
        {
          label: "用户账号",
          prop: "loginName",
        },
        {
          label: "归属企业",
          prop: "orgName",
        },
        {
          label: "电站名称",
          prop: "stationName",
        },
        {
          label: "占用终端名称",
          prop: "deviceName",
        },
        {
          label: "占用终端编码",
          prop: "connectorId",
        },
        {
          label: "占用时长",
          prop: "time",
          template: (index, reocrd) => {
            if (reocrd.flag) {
              return "充电中";
            } else {
              var hours = parseInt(
                (reocrd.time % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
              );
              var minutes = Math.ceil(
                (reocrd.time % (1000 * 60 * 60)) / (1000 * 60)
              );
              if (hours == 0) {
                return minutes + " 分钟 ";
              } else {
                return hours + "小时" + minutes + " 分钟 ";
              }
            }
          },
        },
        {
          label: "订单类型",
          prop: "orderType",
          template: (index, reocrd) => {
            return reocrd.orderType == 0
              ? "平台"
              : reocrd.orderType == 1
              ? "流量方"
              : "--";
          },
        },
        {
          label: "占位开始时间",
          prop: "actalTime",
          width: "150px",
          template: (index, reocrd) => {
            var year = new Date(reocrd.actalTime).getFullYear();
            var month = new Date(reocrd.actalTime).getMonth() + 1;
            var date = new Date(reocrd.actalTime).getDate();
            var hours = new Date(reocrd.actalTime).getHours();
            var minutes = new Date(reocrd.actalTime).getMinutes();
            var seconds = new Date(reocrd.actalTime).getSeconds();
            if (hours < 10) {
              hours = "0" + hours;
            }
            if (minutes < 10) {
              minutes = "0" + minutes;
            }
            if (seconds < 10) {
              seconds = "0" + seconds;
            }
            var time =
              year +
              "-" +
              month +
              "-" +
              date +
              " " +
              hours +
              ":" +
              minutes +
              ":" +
              seconds;
            return time;
          },
        },
      ],
      // 操作栏
      handles: {
        width: 300,
        btns: [
          {
            label: "详情",
            icon: "el-icon-view",
            permission: "order.stationrealtime.details",
            handle: (resp) => {
              this.$router.push({
                path: "./orderStationmanagementDetail",
                query: { id: resp.id, num: resp.startChargeSeq },
              });
            },
          },
          {
            label: "终止充电",
            permission: "order.stationrealtime.stop",
            isConfirm: true,
            confirmText: "确定要终止充电吗？",
            url: "/evserv/newApi/query_stop_charge",
            method: "post",
            before: (index, record) => {
              return {
                connectorId: record.connectorCode,
                startChargeSeq: record.startChargeSeq,
              };
            },
            handle: (resp) => {
              this.$notify({
                title: "成功",
                message: "终止充电成功",
                type: "success",
              });
              this.$refs.tableref.queryTable();
            },
          },
          // {
          //   label:"重置用户充电状态",
          //   style:"color:red",
          //   permission:"",
          //   isConfirm: true,
          //   confirmText:"确认重置用户充电状态吗？（请谨慎点击）",
          //   url:"/finance/order/reSetUserChargingStatus",
          //   method:"get",
          //   before: (index, record) => {
          //     return {
          //       id: record.id
          //     };
          //   },
          //   handle: resp => {
          //     this.$refs.tableref.queryTable();
          //   }
          // }
          {
            label: "转为待处理订单",
            style: "color:red",
            permission: "order.stationrealtime.processed",
            isConfirm: true,
            confirmText: "确认转为待处理订单吗？（请谨慎点击）",
            url: "/finance/order/converToEx",
            method: "get",
            before: (index, record) => {
              return {
                startChargeSeq: record.startChargeSeq,
              };
            },
            handle: (resp) => {
              this.$refs.tableref.queryTable();
            },
          },
        ],
      },
      // 操作栏
      handles1: {
        width: 200,
        btns: [
          {
            label: "详情",
            permission: "order.stationrealtime.details",
            handle: (resp) => {
              this.$router.push({
                path: "./occupyDetail",
                query: { id: resp.id, pageState: 1 },
              });
            },
          },
          {
            label: "手动结束",
            permission: "order.stationrealtime.stop",
            handle: (resp) => {
              this.$router.push({
                path: "./occupyDetail",
                query: { id: resp.id, pageState: 2 },
              });
            },
          },
        ],
      },
      query: [
        {
          label: "开始时间",
          prop: "startTime",
          placeholder: "",
          type: "date2",
        },
        {
          label: "充电单号",
          prop: "startChargeSeq",
          placeholder: "请输入充电单号",
        },
        {
          label: "充电方式",
          prop: "chargeType",
          placeholder: "请输入充电方式",
          type: "select",
          data: [
            {
              label: "平台APP",
              value: "APP",
            },
            {
              label: "平台小程序",
              value: "WSP",
            },
            {
              label: "平台刷卡",
              value: "CARD",
            },
            {
              label: "第三方",
              value: "OTHER",
            },
            {
              label: "VIN码充电",
              value: "VIN",
            },
          ],
        },
        {
          label: "订单类型",
          prop: "orderType",
          placeholder: "请选择订单类型",
          type: "select",
          data: [
            {
              label: "平台",
              value: 0,
            },
            {
              label: "流量方",
              value: 1,
            },
            // {
            //   label: "车辆机构",
            //   value: 2,
            // },
          ],
        },
        {
          label: "用户账号",
          prop: "loginName",
          placeholder: "请输入用户账号",
        },
        {
          label: "用户姓名",
          prop: "userName",
          placeholder: "请输入用户姓名",
        },
        {
          label: "归属企业",
          prop: "belongOrg",
          placeholder: "请输入归属企业",
        },
        {
          label: "运营商属性",
          prop: "orgType",
          placeholder: "请选择运营商属性",
          type: "select",
          data: [
            {
              label: "自营",
              value: 1,
            },
            {
              label: "加盟",
              value: 2,
            },
            {
              label: "互联互通",
              value: 3,
            },
          ],
        },
        {
          label: "电站名称",
          prop: "stationName",
          placeholder: "请输入电站名称",
        },
        {
          label: "终端名称",
          prop: "connectorName",
          placeholder: "请输入终端名称",
        },
        {
          label: "运营商",
          prop: "orgName",
          placeholder: "请输入运营商",
        },
        {
          label: "充电车辆",
          prop: "plateNumber",
          placeholder: "请输入充电车辆",
        },
        // {
        //   label: "充电模式",
        //   prop: "chargingType",
        //   placeholder: "请选择充电模式",
        //   type: "select",
        //   data: [
        //     {
        //       label: "单充",
        //       value: 0,
        //     },
        //     {
        //       label: "双枪并充",
        //       value: 1,
        //     },
        //   ],
        // },
      ],
      query1: [
        {
          label: "开始充电",
          prop: "startTime",
          placeholder: "",
          type: "date2",
        },
        {
          label: "用户账号",
          prop: "loginName",
          placeholder: "请输入用户账号",
        },
        {
          label: "归属企业",
          prop: "orgName",
          placeholder: "请输入归属企业",
        },
        {
          label: "电站名称",
          prop: "stationName",
          placeholder: "请输入电站名称",
        },
        {
          label: "占用终端编码",
          prop: "connectorId",
          placeholder: "请输入占用终端编码",
        },
      ],
    };
  },
  computed: {},
  mounted() {
    // const tabs = localStorage.getItem("tabName");
    // if (tabs === "second") {
    //   this.tabName = "second";
    // }
    // localStorage.removeItem("tabName");
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {
    const tabs = localStorage.getItem("tabName");
    if (tabs === "second") {
      this.tabName = "second";
    }
    localStorage.removeItem("tabName");
  }, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {},
  methods: {}, // 如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style lang="less" src="" scoped>
</style>



// WEBPACK FOOTER //
// src/views/orderManagement/orderStationmanagement.vue